// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // For Material Icons
import { VFileUpload } from 'vuetify/labs/VFileUpload';

import 'vuetify/styles';
import { fr, en, es } from 'vuetify/locale';

const knaNatoTheme: ThemeDefinition = {
    dark: false,
    colors: {
        background: '#FFFFFF',
        surface: '#FFFFFF',
        // primary: '#F05A21',
        // 'primary-darken-1': '#C83E05',
        secondary: '#03DAC6',
        'secondary-darken-1': '#018786',
        error: '#B00020',
        info: '#2196F3',
        // success: '#4CAF50',
        // warning: '#FB8C00',
        // danger
        danger: '#c41c1c',
        'danger-050': '#fef6f6',
        'danger-100': '#fce4e4',
        'danger-200': '#f7c5c5',
        'danger-300': '#f09898',
        'danger-400': '#e47474',
        'danger-600': '#a51818',
        'danger-700': '#c41c1c',
        'danger-800': '#7d1212',
        'danger-900': '#240505',
        // netrual
        'netrual-050': '#fbfcfe',
        'netrual-100': '#f0f4f8',
        'netrual-200': '#dde7ee',
        'netrual-300': '#cdd7e1',
        'netrual-400': '#9fa6ad',
        netrual: '#636b74',
        'netrual-600': '#555e68',
        'netrual-700': '#32383e',
        'netrual-800': '#171a1c',
        'netrual-900': '#0b0d0e',
        // primary
        'primary-050': '#ffe1d1',
        'primary-100': '#ffd0a6',
        'primary-200': '#ffb37a',
        'primary-300': '#ff9a47',
        'primary-400': '#ff7f1a',
        primary: '#dc4405',
        'primary-600': '#c23803',
        'primary-700': '#9f3302',
        'primary-800': '#803002',
        'primary-900': '#661e01',
        // accent-01
        'accent-01-050': '#fdebfe',
        'accent-01-100': '#ff51f8',
        'accent-01-200': '#4a0a49',
        // accent-02
        'accent-02-050': '#e0f7f7',
        'accent-02-100': '#009999',
        'accent-02-200': '#003333',
        // accent-03
        'accent-03-050': '#e7f1ff',
        'accent-03-100': '#3787ff',
        'accent-03-200': '#0a1f4a',
        // accent-04
        'accent-04-050': '#f0e5fc',
        'accent-04-100': '#991fea',
        'accent-04-200': '#2a0540',
        // success
        'success-050': '#f6fef6',
        'success-100': '#e3fbe3',
        'success-200': '#c7f7c7',
        'success-300': '#a1e8a1',
        'success-400': '#51bc51',
        success: '#1f7a1f',
        'success-600': '#136c13',
        'success-700': '#0a470a',
        'success-800': '#042f04',
        'success-900': '#021d02',
        // warning
        'warning-050': '#fefaf6',
        'warning-100': '#fdf0e1',
        'warning-200': '#fce1c2',
        'warning-300': '#ea9a3e',
        'warning-400': '#ea9a3e',
        warning: '#9a5b13',
        'warning-600': '#72430d',
        'warning-700': '#492b08',
        'warning-800': '#2e1b05',
        'warning-900': '#1d1002',
        // text
        'text-050': '#888b8d',
        'text-100': '#3a3c3c',
        'text-200': '#5a5c5d',
        'text-300': '#6f7274',
    },
    variables: {
        'text-field-border-radius': '0px',
        'border-radius-root': '0px',
        'button-text-transform': 'lowercase',
        'body-font-family': 'Inter, sans-serif',
        'heading-font-family': 'Arial Black, sans-serif',
        'heading-colory': '#3a3c3c',
        'body-colory': '#5a5c5d',
    },
};

// Vuetify
import { createVuetify, type ThemeDefinition } from 'vuetify';
import { aliases, md } from 'vuetify/iconsets/md';

export default createVuetify({
    components: {
        VFileUpload,
    },
    icons: {
        defaultSet: 'md',
        aliases,
        sets: {
            md,
        },
    },
    locale: {
        locale: 'en',
        fallback: 'en',
        messages: {
            en,
            fr,
            es,
        },
    },
    theme: {
        defaultTheme: 'knaNatoTheme',
        themes: {
            knaNatoTheme,
        },
    },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
